import React, { useEffect, useState } from "react";
import { Image, Box, Text, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";

const GlobalLoading: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [display, setDisplay] = useState("none");

  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let initialLoadingStartTime: number;

    const handleShowLoading = (e: CustomEvent) => {
      setIsLoading(true);
      setDisplay("flex");
      setMessage(e.detail.message || "");
      initialLoadingStartTime = Date.now();
    };

    const handleHideLoading = () => {
      const loadingTime = Date.now() - initialLoadingStartTime;
      if (loadingTime < 2000) {
        setTimeout(() => {
          setIsLoading(false);
          setTimeout(() => {
            setDisplay("none");
            setMessage("");
          }, 500);
        }, 2000 - loadingTime);
        return;
      }
      setIsLoading(false);

      setTimeout(() => {
        setDisplay("none");
        setMessage("");
      }, 500);
    };

    window.addEventListener("showLoading", handleShowLoading as EventListener);
    window.addEventListener("hideLoading", handleHideLoading as EventListener);

    return () => {
      window.removeEventListener(
        "showLoading",
        handleShowLoading as EventListener
      );
      window.removeEventListener(
        "hideLoading",
        handleHideLoading as EventListener
      );
    };
  }, []);

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      backgroundColor="rgba(255, 255, 255, 0.7)"
      justifyContent="center"
      alignItems="center"
      zIndex={1401}
      color="white"
      fontSize="1.5rem"
      textAlign="center"
      padding="1rem"
      backdropBlur={"sm"}
      backdropFilter={"blur(10px)"}
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoading ? 1 : 0 }}
      display={display}
    >
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={"1rem"}
        padding={"4rem"}
        borderRadius={"8px"}
      >
        <Image
          src="https://adtech-logo.s3.eu-central-1.amazonaws.com/gamelight-1.png"
          alt="Loading"
          objectFit="contain"
          animation="bounce 1.5s infinite"
          width="100%"
          height="100%"
          maxWidth={"8rem"}
          maxHeight={150}
        />

        {message && (
          <p
            style={{
              color: "black",
              fontWeight: "inherit",
              padding: "0.5rem 1rem",
              borderRadius: "8px",
            }}
          >
            {message}
            {dots}
          </p>
        )}
      </Flex>

      <style>
        {`
          @keyframes bounce {
            0%, 100% {
              /* transform: translateY(0); */
              scale:1;
              opacity: 1;
            }
            50% {
           /*    transform: translateY(-30px); */
              scale:0.95;
              opacity: 0.5;
            }
          }
        `}
      </style>
    </Flex>
  );
};

export default GlobalLoading;

export const showGlobalLoading = (message: string = "") => {
  const event = new CustomEvent("showLoading", {
    detail: { message },
  });
  window.dispatchEvent(event);
};

export const hideGlobalLoading = () => {
  const event = new CustomEvent("hideLoading");
  window.dispatchEvent(event);
};
